module.exports = __webpack_public_path__ + "static/img/banner3.07500c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ad/banner3.png
// module id = Vk3c
// module chunks = 1